import { render } from "./business-cofounder-modal.vue?vue&type=template&id=18234325&ts=true"
import script from "./business-cofounder-modal.vue?vue&type=script&lang=ts"
export * from "./business-cofounder-modal.vue?vue&type=script&lang=ts"

import "./business-cofounder-modal.vue?vue&type=style&index=0&id=18234325&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__